import { ValidationError, AnySchema } from 'yup';

export const validate = <T>(schema: AnySchema, value: T) => {
    let errors: string[] = [];
    try {
        schema.validateSync(value);
    } catch (err) {
        if (err instanceof ValidationError) {
            errors = err.errors;
        } else {
            console.log(err);
        }
    }
    return errors;
}
